<template>
  <div>
    <a-card :title="$t('拣货出库')">
      <a-button slot="extra" type="primary" ghost @click="goBack"><a-icon type="left" />{{ $t("返回") }}</a-button>

      <a-form-model ref="form" :model="form" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }">
        <a-row>
          <a-col :span="24" style="width: 380px">
            <a-form-model-item prop="pallet_quantity" :label="$t('托盘数量')">
              <a-input-number v-model="form.pallet_quantity" style="width: 100%" />
            </a-form-model-item>
          </a-col>
          <a-col :span="24" style="width: 380px">
            <a-form-model-item prop="remark" :label="$t('备注')">
              <a-input v-model="form.remark" allowClear />
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
      <a-divider />

      <div style="margin-top: 16px">
        <a-table
          rowKey="id"
          size="small"
          :loading="tableLoading"
          :columns="curColumns"
          :data-source="pickingMaterialItems"
          :pagination="false"
          :scroll="{ x: 1620 }"
        >
          <div slot="picking_quantity" slot-scope="value, item, index">
            <a-input-number
              v-model="item.picking_quantity"
              :min="0"
              size="small"
              @change="changeQuantity(item)"
            ></a-input-number>
          </div>
          <div slot="charge_value" slot-scope="value, item">
            <a-input-number v-model="item.charge_value" size="small" />
          </div>
          <div slot="total_weight" slot-scope="value, item">
            <a-input-number v-model="item.total_weight" size="small" />
          </div>
          <div slot="total_area" slot-scope="value, item">
            <a-input-number v-model="item.total_area" size="small" />
          </div>
          <div slot="total_volume" slot-scope="value, item">
            <a-input-number v-model="item.total_volume" size="small" />
          </div>
          <template slot="sub_batch" slot-scope="value, item, index">
            <a-select v-model="item.sub_batch" :placeholder="$t('请输入或选择库位')" size="small" style="width: 100%">
              <a-select-option
                v-for="inventoryItem in item.inventory_items.filter(
                  (inventory_item) => !$route.query.area || $route.query.area == inventory_item.reservoir_area
                )"
                :key="inventoryItem.id"
                :value="inventoryItem.id"
                >{{ inventoryItem.location_number }} | {{ $t("库存") }}{{ inventoryItem.remain_quantity }} |
                {{ inventoryItem.status_display }}</a-select-option
              >
            </a-select>
          </template>
          <div slot="action" slot-scope="value, item, index">
            <a-button-group size="small">
              <a-button type="danger" @click="removeMaterial(item, index)">{{ $t("删除") }}</a-button>
              <a-button type="primary" @click="copyMaterial(item, index)">{{ $t("复制") }}</a-button>
            </a-button-group>
          </div>
        </a-table>
      </div>

      <div style="margin-top: 32px">
        <a-popconfirm :title="$t('确定创建吗?')" @confirm="create">
          <a-button type="primary" :loading="createLoading">{{ $t("创建") }}</a-button>
        </a-popconfirm>
      </div>
    </a-card>
  </div>
</template>

<script>
import { pickingCreateMaterials, quickPicking } from "@/api/stockOut";
import NP from "number-precision";

export default {
  data() {
    return {
      tableLoading: false,
      createLoading: false,
      pickingOrderId: null,
      pickingMaterialItems: [],
      form: { pallet_quantity: 0, remark: "" },
      columns: [
        {
          title: this.$t("序号"),
          dataIndex: "index",
          fixed: "left",
          width: 60,
          customRender: (value, item, index) => index + 1,
        },
        {
          title: this.$t("货品名称"),
          dataIndex: "material_name",
          ellipsis: true,
          fixed: "left",
          width: 150,
        },
        {
          title: this.$t("库位"),
          dataIndex: "sub_batch",
          width: 240,
          scopedSlots: { customRender: "sub_batch" },
        },
        {
          title: this.$t("拣货数量"),
          dataIndex: "picking_quantity",
          width: 100,
          scopedSlots: { customRender: "picking_quantity" },
        },
        {
          title: this.$t("拣货重量(吨)"),
          dataIndex: "total_weight",
          width: 120,
          scopedSlots: { customRender: "total_weight" },
        },
        {
          title: this.$t("拣货面积(平方米)"),
          dataIndex: "total_area",
          width: 140,
          scopedSlots: { customRender: "total_area" },
        },
        {
          title: this.$t("拣货体积(立方米)"),
          dataIndex: "total_volume",
          width: 140,
          scopedSlots: { customRender: "total_volume" },
        },
        // {
        //   title: this.$t("计费量"),
        //   dataIndex: "charge_value",
        //   key: "charge_value",
        //   width: 100,
        //   scopedSlots: { customRender: "charge_value" },
        // },
        {
          title: this.$t("货品编号"),
          dataIndex: "material_number",
          ellipsis: true,
          width: 180,
        },
        {
          title: this.$t("待拣货数量"),
          dataIndex: "remain_quantity",
          ellipsis: true,
          width: 100,
        },
        {
          title: this.$t("批次"),
          dataIndex: "batch_number",
          ellipsis: true,
          width: 180,
        },
        {
          title: this.$t("单位"),
          dataIndex: "unit",
          ellipsis: true,
          width: 100,
        },
        // {
        //   title: this.$t("计费单位"),
        //   dataIndex: "charge_unit_display",
        //   ellipsis: true,
        //   width: 100,
        //   key: "charge_unit",
        // },
        {
          title: this.$t("操作"),
          dataIndex: "action",
          fixed: "right",
          width: 120,
          scopedSlots: { customRender: "action" },
        },
      ],
    };
  },
  computed: {
    enableCharge() {
      return this.$store.state.user.enableCharge;
    },
    curColumns() {
      const items = [];
      for (const item of this.columns) {
        if (!this.enableCharge && item.key === "charge_value") {
          continue;
        }

        if (!this.enableCharge && item.key === "charge_unit") {
          continue;
        }

        items.push(item);
      }
      return items;
    },
  },
  methods: {
    initData() {
      this.pickingOrderId = this.$route.query.id;
      this.getPickingMaterials();
    },
    goBack() {
      this.$router.go(-1);
    },
    getPickingMaterials() {
      this.tableLoading = true;
      pickingCreateMaterials({ id: this.$route.query.id })
        .then((data) => {
          let pickingMaterialItems = [];
          for (let item of data) {
            if (item.remain_quantity > 0) {
              // 推荐库位
              if (item.recommend_location_items.length > 0) {
                for (let recommend_location_item of item.recommend_location_items) {
                  if (!item.inventory_items.some((i) => i.id === recommend_location_item.sub_batch)) {
                    continue;
                  }

                  pickingMaterialItems.push({
                    ...item,
                    sub_batch: recommend_location_item.sub_batch,
                    charge_value: 0,
                    total_weight: NP.times(recommend_location_item.remain_quantity, item.unit_weight, 0.001),
                    total_area: NP.times(recommend_location_item.remain_quantity, item.unit_area),
                    total_volume: NP.times(recommend_location_item.remain_quantity, item.unit_volume),
                    picking_quantity: recommend_location_item.remain_quantity,
                  });
                }
              } else {
                pickingMaterialItems.push({
                  ...item,
                  total_weight: 0,
                  total_area: 0,
                  total_volume: 0,
                  charge_value: 0,
                  picking_quantity: 0,
                });
              }
            }
          }

          this.pickingMaterialItems = pickingMaterialItems;
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },
    create() {
      if (this.pickingMaterialItems.length == 0) {
        this.$message.warn(this.$t("没有货品"));
        return;
      }

      for (let item of this.pickingMaterialItems) {
        if (!item.sub_batch) {
          this.$message.warn(this.$t("未选择库位"));
          return;
        }
      }

      let pickingMaterialItems = [];
      for (let item of this.pickingMaterialItems) {
        if (item.picking_quantity > 0 && item.sub_batch) {
          pickingMaterialItems.push({
            picking_material: item.id,
            sub_batch: item.sub_batch,
            charge_value: item.charge_value,

            total_weight: NP.times(item.unit_weight, item.picking_quantity, 0.001),
            total_area: NP.times(item.unit_area, item.picking_quantity),
            total_volume: NP.times(item.unit_volume, item.picking_quantity),
            total_quantity: item.picking_quantity,
          });
        }
      }

      this.createLoading = true;
      quickPicking({
        id: this.pickingOrderId,
        ...this.form,
        picking_record_material_items: pickingMaterialItems,
      })
        .then((data) => {
          this.$message.success(this.$t("创建成功"));
          this.$router.go(-1);
        })
        .finally(() => {
          this.createLoading = false;
        });
    },
    removeMaterial(item, index) {
      this.pickingMaterialItems.splice(index, 1);
    },
    copyMaterial(item, index) {
      this.pickingMaterialItems.splice(index, 0, { ...item });
    },
    autoPicking(item, index) {
      let materialItems = [];
      let remainQuantity = item.picking_quantity;

      for (let subBatchItem of item.recommend_location_items) {
        if (remainQuantity > subBatchItem.remain_quantity) {
          materialItems.push({
            ...item,
            sub_batch: subBatchItem.id,
            location_number: subBatchItem.location_number,
            picking_quantity: subBatchItem.remain_quantity,
          });

          remainQuantity -= subBatchItem.remain_quantity;
        } else {
          materialItems.push({
            ...item,
            sub_batch: subBatchItem.id,
            location_number: subBatchItem.location_number,
            picking_quantity: remainQuantity,
          });

          break;
        }
      }
      this.pickingMaterialItems.splice(index, 1, ...materialItems);
    },
    changeQuantity(item) {
      item.total_weight = NP.times(item.picking_quantity, item.unit_weight, 0.001);
      item.total_area = NP.times(item.picking_quantity, item.unit_area);
      item.total_volume = NP.times(item.picking_quantity, item.unit_volume);
    },
  },
  mounted() {
    this.initData();
  },
};
</script>

<style scoped></style>
